export default __webpack_public_path__ + "static/media/value_03.746be326.png";